module.exports = __webpack_public_path__ + "media/packs/user-cards/images/menu-16471e889312c7e0268934f5cb65f961.svg";